/**
 * Parse a name from a list of strings. Filters out empty strings and trims the result.
 * @param names The list of strings to parse.
 * @returns The parsed name.
 */
export const parseName = (...names: string[]) => names.filter(Boolean).join(' ').trim() || null;
